import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import QuoteGenerator from "../components/QuoteGenerator";
import "../assets/css/AddTenant.css";

function QuoteGeneratorPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { customerData, type, clientId } = location.state || {};

  return (
    <div className="addtenant-container quote-generator-page-container">
      <QuoteGenerator
        standalone
        isOpen={true}
        onClose={() => navigate(-1)}
        customerData={customerData}
        type={type || "client"}
        clientId={clientId || null}
        hideBackInHeader
      />
    </div>
  );
}

export default QuoteGeneratorPage;
